<div class="wrapper-form">
    
    <!-- Sign in form -->
    <form class="form" [formGroup]="signInForm" (ngSubmit)="onSubmitSignIn()" *ngIf="!showReset" [ngClass]="{'error' : signInError}">
        <div class="title">
            <span>Willkommen</span>
        </div>
        <div class="form-floating mt-3">
            <input type="email" class="form-control" id="controlEmail" placeholder="E-Mail Adresse" formControlName="email">
            <label for="controlEmail">E-Mail Adresse</label>
        </div>
        <hr>
        <div class="input-group mt-3">
            <div class="form-floating">
                <input [type]="passwordControlType" class="form-control" id="controlEmail" placeholder="Passwort" formControlName="password">
                <label for="controlEmail">Passwort</label>
            </div>
            <button type="button" class="btn" (click)="togglePassword()">
                <i class="fa fa-fw" [ngClass]="{'fa-eye' : passwordControlType == 'text', 'fa-eye-slash' : passwordControlType == 'password'}" aria-hidden="true"></i>
            </button>
        </div>
        <hr>
        <div class="d-flex justify-content-end controls mt-3">
            <button type="button" class="btn btn-reset" (click)="showResetForm()">Passwort zurücksetzen</button>
        </div>
        <div class="d-flex justify-content-end controls mt-3">
            <button type="submit" class="btn btn-green btn-submit" [disabled]="signInForm.invalid || disableSignInBtn">Anmelden</button>
        </div>
    </form>
    
    <!-- Password reset form  -->
    <form class="form" [formGroup]="resetForm" (ngSubmit)="onSubmitReset()" *ngIf="showReset" [ngClass]="{'error' : resetError}">
        <div class="title">
            <span>Passwort zurücksetzen</span>
        </div>
        <div class="form-floating mt-3">
            <input type="email" class="form-control" id="controlEmail" placeholder="E-Mail Adresse" formControlName="email">
            <label for="controlEmail">E-Mail Adresse</label>
        </div>
        <hr>
        <div class="d-flex justify-content-end controls mt-3">
            <button type="button" class="btn btn-signin" (click)="showSignInForm()">Einloggen</button>
        </div>
        <div class="d-flex justify-content-between controls mt-3">
            <div class="reset-success">
                <div *ngIf="resetSuccess">
                    Es wurde eine E-Mail an die angegebene Adresse gesendet. Bitte folgen Sie den Anweisungen in der E-Mail.
                </div>
            </div>
            <button type="submit" class="btn btn-green btn-submit" [disabled]="resetForm.invalid || disableResetBtn">Zurücksetzen</button>
        </div>
    </form>
</div>
